<template>
  <i
    class="tm-audio-border"
    :class="{
      f: $props.isFirst,
      l: $props.isLast,
      s: $props.isSelected,
      h: $props.showDim,
    }"
  />
</template>

<script>
export default {
  name: 'tm-audio-border',
  props: {
    isFirst: { type: Boolean, required: true },
    isLast: { type: Boolean, required: true },
    isSelected: { type: Boolean, required: true },
    showDim: { type: Boolean, required: true },
  },
};
</script>

<style lang="scss">
.tm-audio-span .tm-audio-border {
  --border-style: solid;
  --border-colour: var(--tm-audioBorder1);
  --border-width: var(--tm-audioBorderW1);

  position: absolute;
  top: 0;
  pointer-events: none;
  z-index: var(--tm-zVisualBorder);

  &.s {
    --border-colour: var(--tm-audioBorder2);
    --border-width: var(--tm-audioBorderW2);
  }

  &.f {
    border-left: var(--border-width) var(--border-style) var(--border-colour);
  }

  &.l {
    border-right: var(--border-width) var(--border-style) var(--border-colour);
  }

  &.h {
    background-color: var(--tm-audioTrackHover);
  }

  border-top: var(--border-width) var(--border-style) var(--border-colour);
  border-bottom: var(--border-width) var(--border-style) var(--border-colour);
}
</style>
